import { useEffect, useState } from "react"
import { getDaypassByDateAdmin } from "../../services/daypass";
import { Box, Flex, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Pie } from "react-chartjs-2";


export const AmenidadesAdm = () => {
    const today = new Date();
    const { t } = useTranslation();
    const [dateFilter, setDateFilter] = useState(`${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`);

    const [dayPassList, setDayPassList] = useState([]);
    const [cupo, setCupo] = useState(0);

    const requestDayPass = async () => {
        try {
            const response = await getDaypassByDateAdmin(dateFilter);
            if (response.status === 200) {
                setDayPassList(response.data.reservas);
                setCupo(response.data.cupo);
            } else {
                setDayPassList([]);
            }
        } catch (error) {
            console.error("Error fetching day pass data:", error);
            setDayPassList([]);
        }
    }

    const getPieChartData = () => {
        if (!dayPassList){
            return null;
        }
        const ocupados = dayPassList.reduce((acc, daypass) => acc + daypass.numPersonas, 0);
        const disponibles = cupo - ocupados;

        return {
            labels: [t('OCCUPIED'), t('AVAILABLE')],
            datasets: [
                {
                    data: [ocupados, disponibles],
                    backgroundColor: ['#f56565', '#68d391'],
                    borderColor: ['#e53e3e', '#48bb78'],
                    borderWidth: 1,
                },
            ],
        };
    };

    useEffect(() => {
        requestDayPass();
    }, [dateFilter])

    return (
        <div className="mt-lg-3 mx-lg-5 m-2">
            <h2 className="text-center mb-4">Reservaciones de Day Pass</h2>
            <div className="forrm-group" style={{ maxWidth: '500px', width: '100%' }}>
                <label htmlFor="dateFilter">Filtrar por fecha:</label>
                <input
                    type="date"
                    id="dateFilter"
                    className="form-control"
                    value={dateFilter}
                    onChange={(e) => setDateFilter(e.target.value)}
                />
            </div>
            <Flex
                direction={{ base: "column", lg: "row" }} // Stack vertically on mobile, horizontally on larger screens
                gap={4}>
                    <Box
                        flex={{ base: "1", lg: "3" }} // Full width on mobile, 75% width on larger screens
                        bg="white"
                        p={4}
                    >
                        <TableContainer>
                            <Table variant={"simple"} className="campina-table">
                                <Thead>
                                    <Tr>
                                        <Th>Titular</Th>
                                        <Th>Email</Th>
                                        <Th>Membresía</Th>
                                        <Th>Número de personas</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {dayPassList.length > 0 ? (
                                        dayPassList.map((daypass, index) => (
                                            <Tr key={index}>
                                                <Td>
                                                    {`${daypass.titular.nombre} ${daypass.titular.apellidos}`}
                                                </Td>
                                                <Td>{daypass.titular.correo}</Td>
                                                <Td>{daypass.titular.membresia}</Td>
                                                <Td>{daypass.numPersonas}</Td>
                                            </Tr>
                                        ))
                                    ) : (
                                        <Tr>
                                            <td colSpan="4" className="text-center">No hay reservaciones para esta fecha</td>
                                        </Tr>
                                    )}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box
                        flex={{ base: "1", lg: "1" }} // Full width on mobile, 25% width on larger screens
                        bg="white"
                        p={4}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Pie data={getPieChartData()} height={300} width={300} options={{ responsive: true, maintainAspectRatio: false }} />
                    </Box>
            </Flex>
        </div>
    )
}